import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};
